<template>
<div class="mcontainer">
  <van-nav-bar fixed title="我要咨询" left-text="返回" left-arrow @click-left="back" />
  <div class="main__body">
    <div class="todo__btn">
      <van-cell-group>
        <van-cell icon="comment-o" title="去咨询" is-link @click="$utils.jump('/ask?from=askNoAuth')" />
        <van-cell icon="comment" title="查询咨询信息" is-link @click="$utils.jump('/askCheck')" />
      </van-cell-group>
    </div>
  </div>
</div>
</template>
<script>
import {
  mapActions
}
from 'vuex'
export default {
  components: {},
  data() {
    return {}
  },
  props: [],
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    back() {
      this.$utils.jump('/?type=3')
    },
    ...mapActions('api', [])
  }
}
</script>
<style lang="less" scoped>
.mcontainer {
    .main__body {
        margin-top: 46px;
        background: #fff;
        min-height: calc(100vh - 46px);
    }
}
</style>
